// library imports
import { Route, Routes } from "react-router-dom";

// User Component imports
import * as SceneConfig from "_core/configs/SceneConfig";
import AdminUserEdit from "./parts/AdminUserEdit";
import AdminUserChatLog from "./parts/AdminUserChatLog";
import AdminUserChatReport from "./parts/AdminUserChatReport";
import AdminUserProfileEdit from "./parts/AdminUserProfileEdit";

import AdminUserRagStructure from "./parts/AdminUserRagStructure";
import AdminUserRagUpload from "./parts/AdminUserRagUpload";
import AdminUserRagPlayground from "./parts/AdminUserRagPlayground";
import AdminUserRagEvaluate from "./parts/AdminUserRagEvaluate";
import AdminWelcomeMsgEdit from "./parts/AdminWelcomeMsgEdit";
import AdminHrNewsEdit from "./parts/AdminHrNewsEdit";

const AdminScene = () => {

    return (
        <div id="Admin" className="scene-parent-root">
            <Routes>
                <Route path={SceneConfig.PARTS_ADMIN_USEREDIT}                   element={<AdminUserEdit />} />
                <Route path={SceneConfig.PARTS_ADMIN_USER_CHATLOG}               element={<AdminUserChatLog />} />
                <Route path={SceneConfig.PARTS_ADMIN_USER_CHATREPORT}            element={<AdminUserChatReport />} />
                <Route path={SceneConfig.PARTS_ADMIN_USER_PROFILE_EDIT}          element={<AdminUserProfileEdit />} />
                <Route path={SceneConfig.PARTS_ADMIN_USER_RAG_STRUCTURE}         element={<AdminUserRagStructure />} />
                <Route path={SceneConfig.PARTS_ADMIN_USER_RAG_UPLOAD}            element={<AdminUserRagUpload />} />
                <Route path={SceneConfig.PARTS_ADMIN_USER_RAG_EVALUATE}          element={<AdminUserRagEvaluate />} />
                <Route path={SceneConfig.PARTS_ADMIN_USER_RAG_PLAYGROUND}        element={<AdminUserRagPlayground />} />
                <Route path={SceneConfig.PARTS_ADMIN_WELCOME_MSG_EDIT}           element={<AdminWelcomeMsgEdit />} />
                <Route path={SceneConfig.PARTS_ADMIN_HR_NEWS_EDIT}               element={<AdminHrNewsEdit />} />
            </Routes>
        </div>
    );
};

export default AdminScene;